import {useState} from "react"

export const MODAL__HELP = 'help'
export const MODAL__SOLUTION_LOAD = 'solution_load'
export const MODAL__SOLUTION_SAVE = 'solution_save'
export const MODAL__SOLUTION_SUGGESTIONS = 'solution_suggestions'
export const MODAL__ADDITIONAL_SOLUTION_SUGGESTIONS = 'additional_solution_suggestions'
export const MODAL__SOLUTION_PRODUCTS = 'solution_products'
export const MODAL__SOLUTION_PRODUCT_ADD = 'solution_product_add'
export const MODAL__SOLUTION_REVIEW = 'solution_review'
export const MODAL__REQUEST_QUOTE = 'request_offer'
export const MODAL__PRIVACY = 'privacy'

export const useModal = () => {
    const [state, setState] = useState([])

    const has = (modal) => {
        return state.includes(modal)
    }

    const open = (modal) => {
        if(!has(modal)) setState(prevState => [...prevState, modal])
    }

    const close = () => {
        setState(prevState => {
            const newState = [...prevState]
            newState.pop()
            return newState
        })
    }

    const getZIndex = (modal) => {
        return state.indexOf(modal) + 3
    }

    const isTop = (modal) => {
        return state[state.length - 1] === modal
    }

    const hasHelp = () => has(MODAL__HELP)
    const openHelp = () => open(MODAL__HELP)
    const hasSolutionLoad = () => has(MODAL__SOLUTION_LOAD)
    const openSolutionLoad = () => open(MODAL__SOLUTION_LOAD)
    const hasSolutionSave = () => has(MODAL__SOLUTION_SAVE)
    const openSolutionSave = () => open(MODAL__SOLUTION_SAVE)
    const hasSolutionSuggestions = () => has(MODAL__SOLUTION_SUGGESTIONS)
    const openSolutionSuggestions = () => open(MODAL__SOLUTION_SUGGESTIONS)
    const hasAdditionalSolutionSuggestions = () => has(MODAL__ADDITIONAL_SOLUTION_SUGGESTIONS)
    const openAdditionalSolutionSuggestions = () => open(MODAL__ADDITIONAL_SOLUTION_SUGGESTIONS)
    const hasSolutionProductAdd = () => has(MODAL__SOLUTION_PRODUCT_ADD)
    const openSolutionProductAdd = () => open(MODAL__SOLUTION_PRODUCT_ADD)
    const hasSolutionProducts = () => has(MODAL__SOLUTION_PRODUCTS)
    const openSolutionProducts = () => open(MODAL__SOLUTION_PRODUCTS)
    const hasSolutionReview = () => has(MODAL__SOLUTION_REVIEW)
    const openSolutionReview = () => open(MODAL__SOLUTION_REVIEW)
    const hasRequestQuote = () => has(MODAL__REQUEST_QUOTE)
    const openRequestQuote = () => open(MODAL__REQUEST_QUOTE)
    const hasPrivacy = () => has(MODAL__PRIVACY)
    const openPrivacy = () => open(MODAL__PRIVACY)

    return {
        close, getZIndex, isTop,
        hasHelp, openHelp,
        hasSolutionLoad, openSolutionLoad,
        hasSolutionSave, openSolutionSave,
        hasSolutionSuggestions, openSolutionSuggestions,
        hasAdditionalSolutionSuggestions, openAdditionalSolutionSuggestions,
        hasSolutionProductAdd, openSolutionProductAdd,
        hasSolutionProducts, openSolutionProducts,
        hasSolutionReview, openSolutionReview,
        hasRequestQuote, openRequestQuote,
        hasPrivacy, openPrivacy
    }
}
